import { ITemplate } from 'pages/revisions-module/template-editor/editors/template/types';

export const DEFAULT_TEMPLATE: ITemplate = {
  template: '',
};
